module.exports = __webpack_public_path__ + "media/application/images/external-services/quickbooks-online-logo-22fe8ba3d3a8452ad1f68d126c0a9394.svg";